import React, {useEffect, useState} from 'react';
import './Home.css';
import Dessert from '../../components/MenuCard/Dessert';
import Drinks from '../../components/MenuCard/Drinks';
import Extras from '../../components/MenuCard/Extras';
import '../../components/MenuCard/MenuCard.css';
import Menus from '../../components/MenuCard/Menus';
import Adds from '../../components/MenuCard/Adds';

const Home = () => {
    const [toggleOnglets, setToggleOnglets] = useState(1);
    const [logo, setLogo] = useState(true);

    const toggle = (index) => {
        setToggleOnglets(index);
        setLogo(false);
    };

    // window.addEventListener('scroll', ()=> {
    //     console.log(window.scrollY);
    //     if (window.scrollY > 10) console.log('coucou');
    //
    //     const onglets = document.querySelector(".onglets");
    //      onglets.classList.add('fixed');
    // })

    const backToTop = () => {
        document.documentElement.scrollTop = 0;
    };
    useEffect(() => {
        const btnBackToTop = document.querySelector('.buttontop');

        window.addEventListener('scroll', () => {
            if (window.scrollY > 300 && window.innerWidth < 650) {
                btnBackToTop.style.display = 'flex';
            } else {
                btnBackToTop.style.display = 'none';
            }
        });
    }, []);

    return (
        <div className='mb-3'>
            <div className='buttontop'>
                <img onClick={backToTop} className='arrow' src='assets/arrow_upward_black_24dp-2.svg' />
            </div>

            <div className='onglets'>
                <a onClick={() => toggle(1)} className={toggleOnglets === 1 ? 'onglet-active ' : 'onglet '}>
                    Hamburgers
                </a>
                <a onClick={() => toggle(2)} className={toggleOnglets === 2 ? 'onglet-active' : 'onglet '}>
                    Extras
                </a>
                <a onClick={() => toggle(3)} className={toggleOnglets === 3 ? 'onglet-active' : 'onglet '}>
                    Suppléments
                </a>
                <a onClick={() => toggle(4)} className={toggleOnglets === 4 ? 'onglet-active' : 'onglet'}>
                    Desserts
                </a>
                <a onClick={() => toggle(5)} className={toggleOnglets === 5 ? 'onglet-active' : 'onglet'}>
                    Boissons
                </a>
            </div>

            <div>
                <Menus onglet={toggleOnglets} />
                <Extras onglet={toggleOnglets} />
                <Adds onglet={toggleOnglets} />
                <Dessert onglet={toggleOnglets} />
                <Drinks onglet={toggleOnglets} />
            </div>
            {/*<div style={{textAlign: 'center', marginTop: '1rem'}}>*/}
            {/*    Réalisé par{' '}*/}
            {/*    <a href='https://suits-conception.vercel.app/' style={{textDecoration: 'underline', color: 'black', visited: 'black'}}>*/}
            {/*        Suits Conception*/}
            {/*    </a>*/}
            {/*</div>*/}
        </div>
    );
};

export default Home;
